import './labels.module';
import './labels.config';
import './$labels.factory';

import './components';
import './services';
